import {get, post, postJson} from './axios'

// 签名管理-签名报备（官方）

// const RESOURCE_BASE_PATH = '/jd-yusms'
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/precisionJdSuffix'
const RESOURCE_BASE_PATH = '/sms'

// 签名报备列表（不分页）
export const getPrecisionJdSuffixList = type => get(`${RESOURCE_BASE_PATH}/suffix/${type}`);
